import { useEffect, useState } from "react";
import { formatDate, getColumnValue } from "../../Helpers";

interface FormattedDataProps {
    data: any[];
    columns: {
      id: number;
      label: string;
      property: string;
    }[];
}

const useFormattedData = ({data, columns} : FormattedDataProps ) => {
    const [formattedData, setFormattedData] = useState<any[]>([]);

    /**
     * Formats the data array by mapping over each milestone and formatting the date property using the formatDate function.
     * @param data - The array of milestones to format.
     * @param columns - The array of columns to use for formatting.
     * @returns An array of formatted milestones.
     */
      useEffect(() => {
          const formattedDataArray = data?.map((object) => {
            const formattedMilestone: any = {};
            columns?.map((column) => {
              formattedMilestone[column.property] = formatDate(
                object[column.property]
              );
              if (formattedMilestone[column.property] === undefined) {
                formattedMilestone[column.property] = getColumnValue(
                  object,
                  column
                );
              }
              //if it is a id, add the id to the object
              if (column.property === "id") {
                formattedMilestone.id = object.id;
              }
            });
            return formattedMilestone;
          });
          setFormattedData(formattedDataArray);
      }, [columns, data]);

        return formattedData;
    };

    export default useFormattedData;